import React from 'react';
import SomethingWentWrong from 'src/components/SomethingWentWrong';
import PageLoading from 'src/components/PageLoading';
import { client } from 'src/utils/api-client';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  setActiveOrganization,
  setActiveOrganizationId,
} from 'src/redux-file/platform/slice';
import { usePlatform } from 'src/redux-file/hooks';

// Injects the interceptor to add the token to the requests
// and clears the interceptor when the component is unmounted
export default function Auth(props: { children: React.ReactNode }) {
  const { token } = useParams();
  const [interceptorReady, setInterceptorReady] = React.useState(false);
  React.useEffect(() => {
    const interceptor = client.interceptors.request.use((config) => {
      const newParams = { ...config.params, token };
      config.params = newParams;
      return config;
    });
    setInterceptorReady(true);
    return () => {
      client.interceptors.request.eject(interceptor);
    };
  }, []);
  if (!token) return <SomethingWentWrong />;
  if (!interceptorReady) return <PageLoading />;

  return <EnsureOrganization>{props.children}</EnsureOrganization>;
}

// ensures the organization is set in the redux store
const EnsureOrganization = (props: { children: React.ReactNode }) => {
  const { activeOrganizationId } = usePlatform();
  const dispatch = useDispatch();

  React.useEffect(() => {
    client.get('/web/cbam/survey/organization').then((response) => {
      const organization = response.data;
      dispatch(setActiveOrganization(organization));
      dispatch(setActiveOrganizationId(organization.id));
    });
  }, []);
  if (!activeOrganizationId) return <PageLoading />;
  return props.children as React.ReactElement;
};
